import { Box, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';

import { useStateTablePage } from '../hooks/useStateTablePage';
import { CurrentCarPlaceInfoType } from '../../feature/type/CurrentCarPlaceInfoType';
import { tableColumnList } from '../../const/currentCarPlacePageConst';
import { currentCarPlaceTable } from '../../const/currentCarPlacePageSize';

import theme from '../../../theme';

type Props = {
	currentCarPlaceInfoList: CurrentCarPlaceInfoType[] | [];
	setCenteredCurrentCarPlaceInfo: (value: CurrentCarPlaceInfoType) => void;
};

/**
 * 車両現在位置一覧テーブル
 */
export const CurrentCarPlaceTable = (props: Props) => {
	const { currentCarPlaceInfoList, setCenteredCurrentCarPlaceInfo } = props;

	const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, handleTableRowClick, isRowSelected } = useStateTablePage({
		currentCarPlaceInfoList,
		setCenteredCurrentCarPlaceInfo,
	}); // テーブルページの状態管理用カスタムフック

	return (
		<Box display="flex">
			<Grid container direction="column" justifyContent="center" alignItems="center" spacing={1.5}>
				<Grid item>
					<Paper sx={{ width: currentCarPlaceTable.width, overflow: 'hidden' }}>
						<TableContainer sx={{ maxHeight: currentCarPlaceTable.maxHeight, minHeight: currentCarPlaceTable.minHeight }}>
							<Table stickyHeader size="small" aria-label="currentCarPlaceTable">
								<TableHead>
									<TableRow>
										{tableColumnList.map((tableColumn, index) => (
											<TableCell
												key={index}
												style={{
													minWidth: tableColumn.minWidth,
													fontSize: 12,
													fontWeight: 'bold',
													color: theme.palette.common.black,
													backgroundColor: '#d3d3d3',
												}}
											>
												{tableColumn.label}
											</TableCell>
										))}
									</TableRow>
								</TableHead>
								<TableBody id="currentCarPlaceTableBody">
									{currentCarPlaceInfoList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
										return (
											<TableRow
												hover
												role="checkbox"
												tabIndex={-1}
												key={index}
												onClick={() => {
													handleTableRowClick(row, index);
												}}
												selected={isRowSelected(index, row.carCode)}
												aria-checked={isRowSelected(index, row.carCode)}
											>
												<TableCell key="organizationName">
													{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.organizationName}</Typography>}
												</TableCell>
												<TableCell key="carCode">
													{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.carCode}</Typography>}
												</TableCell>
												<TableCell key="numberPlate">
													{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.numberPlate}</Typography>}
												</TableCell>
												<TableCell key="model">
													{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.model}</Typography>}
												</TableCell>
												<TableCell key="driverName">
													{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.driverName}</Typography>}
												</TableCell>
												<TableCell key="receiveDatetime">
													{<Typography sx={{ fontSize: 12, color: theme.palette.common.black }}>{row.receiveDatetime}</Typography>}
												</TableCell>
											</TableRow>
										);
									})}
								</TableBody>
							</Table>
						</TableContainer>
						<TablePagination
							rowsPerPageOptions={[10, 20]}
							component="div"
							count={currentCarPlaceInfoList.length}
							rowsPerPage={rowsPerPage}
							page={currentCarPlaceInfoList.length ? page : 0}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
						/>
					</Paper>
				</Grid>
			</Grid>
		</Box>
	);
};
